import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { showToastLoading } from '@/utils/tools'
import wx from 'weixin-js-sdk'

export default /*#__PURE__*/_defineComponent({
  __name: 'mini-pay-middle',
  setup(__props) {

// 小程序支付时的中转页
const $route = useRoute()
const state = $route.query.state as string
onMounted(() => {
  showToastLoading()
  setTimeout(() => {
    if (state !== 'success') {
      localStorage.setItem('isCancelPayed', '1')
    }
    wx.miniProgram.navigateBack({
      delta: 1,
      url: '',
    })
  }, 10)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})